<template src="./html/Index.html"></template>

<script>
	import swal from 'sweetalert2'
	import Datatable from './Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'datatable': Datatable,
		},
		data () {
			return {
				//
			}
		},
		methods: {
			destroy (item) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/users/' + item.id)
							.then(response => {
								that.$refs.datatable.reload()
								swal({
									'title': response.body.title,
									'text': response.body.text,
									'type': response.body.type,
								})
							}).catch(function(response) {
								console.log(response)
								that.$refs.datatable.reload()
							})
						})
					}
				}]).catch(swal.noop)
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/users/views/Index.vue